module.exports = __webpack_public_path__ + "img/bg-gc-meal.f1838000.png";